import api, { ResponsePayloadWithData } from '../../../../api';
import { ContentType } from '../../../../api/medialink';
import { Status } from '../../../../utils/results';

export type StudentAssignment = {
  id: string;
  module: string;
  materialId: string;
  materialType: 'user-material' | 'medialink';
  contentType: ContentType;
  name: string;
  from: string;
  to: string;
  repeatable: boolean;
  score: {
    achievable: number;
    achieved: number;
    maximum: number;
    achievedAt?: string;
    status: Status;
  };
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
};

export async function getStudentAssignments(superModuleId: string) {
  const { data } = await api.get<ResponsePayloadWithData<StudentAssignment[]>>(
    `/studio/user/modules/${superModuleId}/assignments/student`,
  );

  return data.data;
}
